import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Modal, ModalControls } from '../../../components/Modal';
import { INVOICE_DIRECTIONS } from '../constants';
import { selectVehicle } from '../../Vehicles/selectors';
import { fetchVehicleProperties } from '../../Vehicles/actions';
import { calculateFinancialAmounts } from '../actions';
import { REQUEST_VEHICLE_PROPERTIES } from '../../Vehicles/constants';
import { selectWork } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import env from '../../../env';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  background-color: white;
  width: 500px;
  height: 300px;
  border-radius: 15px;
  margin: 18px;
  padding: 8px;
`;

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  margin: 12px 0;
`;

const ToggleLabel = styled.span`
  color: red;
`;

const ToggleButton = styled.button`
  height: 50px;
  width: 75px;
  background-color: ${({ active }) => (active ? '#2271d2' : '#848391')};
  color: white;
  cursor: pointer;
  border-radius: 6px;
  margin-left: 12px;
`;

const STATE = {
  answers: {},
};

const WALLSTREET_TASKS = [
  'task_restyle',
  'task_spray',
  'task_interior_polish',
  'task_interior_repair',
  'task_spot_repair',
  'task_desticker',
  'task_window_repair',
  'task_repair',
  'task_int_ext_polish',
  'task_polish_exterior',
  'task_adjust',
];

const QUESTIONS_FIELDS = [
  'transport_requested',
  'transport_outgoing_requested',
  'tasks',
  'sell_with_license_plate',
  'sell_without_license_plate',
  'fix_damages',
  'dont_fix_damages',
];

/* eslint-disable react/prefer-stateless-function */
class InvoiceQuizModalComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.fetchVehicleProperties();
  }

  handleClick = (lbl, val) => {
    if (this.state.answers[lbl] !== val) {
      this.setState(state => ({ answers: { ...state.answers, [lbl]: val } }));
    }
  };

  reset = () => {
    this.setState({ ...STATE });
    this.props.onCancel();
  };

  renderToggler = propName => {
    let isNoChecked = this.state.answers[propName] === undefined;
    let isActive = !!this.state.answers[propName];

    return (
      <ToggleWrapper>
        <ToggleLabel>
          {this.lbl(`invoice.question.${propName}`)}
          {'*'}
        </ToggleLabel>
        <div>
          <ToggleButton active={isActive && !isNoChecked} onClick={() => this.handleClick(propName, 1)}>
            Yes
          </ToggleButton>
          <ToggleButton active={!isActive && !isNoChecked} onClick={() => this.handleClick(propName, 0)}>
            No
          </ToggleButton>
        </div>
      </ToggleWrapper>
    );
  };

  sendAnswers = () => {
    const properties = _.size(this.state.answers)
      ? Object.entries(this.state.answers)?.map(p => ({ propertyName: p[0], propertyValue: p[1] + '' }))
      : [];
    this.props.onConfirm(properties);
  };

  propIsSet(value) {
    if (!value) return null;

    return +value ? 1 : 0;
  }

  render() {
    const { direction } = this.props;
    const vehicle = this.props.fetchedVehicle ?? {};
    let checkWallstreet = 0;
    for (let taskProp of WALLSTREET_TASKS) {
      if (vehicle[taskProp] == 1) {
        checkWallstreet += 1;
        break;
      }
    }

    let questionCount =
      direction === INVOICE_DIRECTIONS.INCOMING
        ? this.propIsSet(vehicle.transport_requested)
        : this.propIsSet(vehicle.transport_outgoing_requested);

    questionCount =
      questionCount +
      this.propIsSet(checkWallstreet) +
      this.propIsSet(vehicle.sell_with_license_plate) +
      this.propIsSet(vehicle.sell_without_license_plate) +
      this.propIsSet(vehicle.fix_damages) +
      this.propIsSet(vehicle.dont_fix_damages);
    console.log('questions: ', questionCount);

    if (vehicle.kenteken_aangevraagd == 1) {
      if (direction === INVOICE_DIRECTIONS.INCOMING) {
        alert(this.lblStr('invoice.question.prompt'));
        this.reset();
      }
    }

    return this.work ? (
      <Loader small />
    ) : (
      <ModalComponent size={'lg'} onClose={this.reset.bind(this)} title={this.lbl('invoice.question.title')}>
        {this.lbl('invoice.question.empty')}

        {direction === INVOICE_DIRECTIONS.INCOMING &&
          vehicle.transport_requested == 1 &&
          this.renderToggler('transport_requested')}
        {direction === INVOICE_DIRECTIONS.OUTGOING &&
          vehicle.transport_outgoing_requested == 1 &&
          this.renderToggler('transport_outgoing_requested')}
        {!!checkWallstreet && this.renderToggler('walstreet_taken')}
        {vehicle.sell_with_license_plate == 1 && this.renderToggler('sell_with_license_plate')}
        {vehicle.sell_without_license_plate == 1 && this.renderToggler('sell_without_license_plate')}
        {vehicle.fix_damages == 1 && this.renderToggler('fix_damages')}
        {vehicle.dont_fix_damages == 1 && this.renderToggler('dont_fix_damages')}

        <div className="d-flex gap-2">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={_.size(this.state.answers) < questionCount}
            onClick={this.sendAnswers}
          >
            {this.lbl('confirm')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

InvoiceQuizModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchedVehicle: selectVehicle(ownProps.vehicle?.id),
    work: selectWork(`${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchVehicleProperties() {
      dispatch(fetchVehicleProperties(ownProps.vehicle?.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceQuizModal = compose(withConnect, withRouter, injectIntl)(InvoiceQuizModalComp);
